<template>
  <basic-container>
    <el-card shadow="hover" class="service-details-card">
      <div slot="header" class="header-title">工单详情</div>
      <div class="details-container">
        <el-card class="details-card">
          <el-row class="cell-content">
            <el-col v-for="(item, index) in propertiesViceList" :key="index" :span="8"
              style="display: flex; align-items: center;">
              <div v-if="item.dataType !== 'img'" style="display: flex;">
                <span class="nameStyle">{{ item.title }}:&nbsp;</span>
                <span v-if="item.dataType == 'star'" style="display: flex;align-items: center;text-align: center;">
                  <el-rate v-model="item.value" disabled></el-rate>
                  <span>{{ item.value == '1' ? '差' : item.value == '2' ? '一般' :
                    item.value == '3' ? '好' : item.value == '4' ? '很好' :
                      item.value
                        == '5' ? '非常好' : '' }}</span>
                </span>
                <span v-else>
                  {{ item.value }}
                </span>
              </div>
              <div style="display: flex; align-items: center;" v-else-if="item.dataType === 'img'">
                <span class="nameStyle">{{ item.title }}: &nbsp;</span>
                <div class="image-container">
                  <viewer :images="formmaterImage(item.value)">
                    <img v-for="src in formmaterImage(item.value)" :src="src" :key="src" class="image" />
                  </viewer>
                </div>
              </div>
            </el-col>
            <el-col :span="8" v-for="(item, index) in serviceFee" :key="index"
              style="display: flex; align-items: center;">
              <div v-if="showBottom">
                <span class="nameStyle">{{ item.key }}</span> :&nbsp;
                <span>{{ item.value }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-card>
  </basic-container>
</template>
<script>
import { serviceListing } from "@/api/work/serviceOrder";
export default {
  name: "ServiceDetails",
  data() {
    return {
      propertiesViceList: [],
      serviceFee: [],
      showBottom: false,
    };
  },
  methods: {
    formmaterImage(row) {
      let str = new Array();
      // console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          if (picArray[i] != "null") {
            str.push(picArray[i]);
          }
        }
      }
      return str;
    },
  },
  mounted() {
    // 获取路由参数中的工单ID
    const rowId = this.$route.query.id;

    // 使用工单ID获取工单信息
    serviceListing(rowId).then((res) => {
      this.propertiesViceList = [];
      this.serviceFee = [];
      let data = JSON.parse(res.data);
      this.propertiesViceList = data.propertiesViceList;
      // 如果数组内的某一对象的value为空，那么就不显示
      for (let i = 0; i < this.propertiesViceList.length; i++) {
        if (this.propertiesViceList[i].value == null) {
          this.propertiesViceList.splice(i, 1);
          i = i - 1;
        }
      }
      if (data.serviceFee.servicePrice) {
        let obj = { key: "收费标准", value: data.serviceFee.servicePrice };
        this.serviceFee.push(obj);
      }
      if (data.serviceFee.otherExpensesAmount) {
        let obj1 = {
          key: "其他费用",
          value: data.serviceFee.otherExpensesAmount,
        };
        this.serviceFee.push(obj1);
      }
      if (data.serviceFee.otherChargesDesc) {
        let obj2 = {
          key: "其他费用备注",
          value: data.serviceFee.otherChargesDesc,
        };
        this.serviceFee.push(obj2);
      }
      let obj3 = { key: "总费用", value: data.serviceFee.servicePriceTotal };
      this.serviceFee.push(obj3);
      if (data.serviceFee.servicePriceTotal != null) {
        this.showBottom = true;
      }
      console.log("工单详情:" + JSON.stringify(this.propertiesViceList));
      console.log("serviceFee:" + JSON.stringify(this.serviceFee));
    });
  },
};
</script>
<style scoped>
.details-container {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.details-card {
  margin-bottom: 20px;
}

.cell-content {
  display: flex;
  flex-wrap: wrap;
}

.cell-content>* {
  min-width: 300px;
  margin-bottom: 10px;
}

.image-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  cursor: pointer;
}

.nameStyle {
  font-weight: bold;
  margin-right: 5px;
}
</style>
